export default "__VITE_ASSET__Qrr$kxFF__"